export default "<div id=\"landing-builder-iframe\"></div>\n"